// The "show your work" donations read (issue #116): the individual donations behind a processor's
// pinned fee estimate for the owed period. Lazily fetched — `enabled` is driven by the expand
// popover's open state, so an unexpanded row costs nothing. The server resolves the SAME window the
// pin was computed over (it takes NO period), so the listed donations reconcile with the shown
// total. This answers "where did this number come from?", never "which donations is this increment
// for?" — the fee has no per-donation attribution.

import type { ProcessorFeeDonationsResponse } from '@signalvote/shared';
import { apiJson } from './apiFetch';
import { campaignHeaders, defineQuery } from '../../lib/data';
import { FINANCE_STALE_TIME } from './queryUtils';

/**
 * The donations feeding a processor's fee estimate for the owed period. The caller passes `skip`
 * until the popover opens, so the list is fetched on demand, not for every pinned row.
 */
export const useProcessorFeeDonations = defineQuery({
  key: (processorId: string) => ['finance', 'processor-fee-donations', processorId],
  reads: 'GET /api/finance/processor-fees/{processorId}/donations',
  staleTime: FINANCE_STALE_TIME,
  fetch: (processorId, { campaignId }): Promise<ProcessorFeeDonationsResponse> =>
    apiJson<ProcessorFeeDonationsResponse>(`/api/finance/processor-fees/${processorId}/donations`, {
      headers: campaignHeaders(campaignId),
      error: 'Failed to load the donations behind this fee',
    }),
});
